import { render, staticRenderFns } from "./Inventorys.vue?vue&type=template&id=b42c5632&"
import script from "./Inventorys.vue?vue&type=script&lang=js&"
export * from "./Inventorys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports